import { render, staticRenderFns } from "./EstadoInscripcionDialog.vue?vue&type=template&id=c07e1b38&"
import script from "./EstadoInscripcionDialog.vue?vue&type=script&lang=js&"
export * from "./EstadoInscripcionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports